import { createUseStyles } from 'react-jss';
import { ITheme } from '../../theme';

export const photoWrapper = {
  padding: '10px',
  borderRadius: '6px',
  border: '1px solid #6CA370',
  display: 'grid',
  gap: '16px',
  gridTemplateColumns: 'repeat(auto-fit, 90px)',
  overflowY: 'auto',
  maxHeight: '236px',

  '&::-webkit-scrollbar': {
    width: '5px',
    borderRadius: '5px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#fff',
    borderRadius: '5px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#CEE8D0',
    borderRadius: '5px',

  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#CEE8D0',
    borderRadius: '5px',
  },
};

type RuleNames =
  | 'img'
  | 'activeImg'
  | 'errors'
  | 'photoError';

const PREFIX = 'PhotoForm';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      img: {
        borderRadius: '4px',
        padding: '2px',
        width: '90px',
        aspectRatio: '1/0.66',
        border: '1px solid transparent',
        transition: 'all 300ms ease',
        objectFit: 'cover',
        '&:hover': {
          border: '1px solid #6CA370',
          cursor: 'pointer',
        },
      },
      activeImg: {
        border: '1px solid #6CA370',
        cursor: 'pointer',
      },
      errors: {
        marginTop: -55,
        position: 'absolute',
        width: 400,
      },
      photoError: {
        border: '1px solid red',
      },
    }
  ),
  { name: PREFIX },
);
